// Leaflet divIcon HTML builders + distance formatting for the dungeon/address
// markers. Shared by home and pinmonkey lobby.
export const formatDist = (m) =>
  m < 1000 ? `${Math.round(m)}m away` : `${(m / 1000).toFixed(1)}km away`;

export const makeDungeonIconHtml = (c) =>
  `<div style="width:16px;height:16px;transform:rotate(45deg);background:${c(
    "background"
  )};border:2px solid ${c("link")};box-shadow:0 0 8px ${c(
    "link",
    0.5
  )};"></div>`;

export const makeDungeonIconFarHtml = (c) =>
  `<div style="width:16px;height:16px;transform:rotate(45deg);background:${c(
    "chrome"
  )};border:2px solid ${c("foreground", 0.2)};"></div>`;

export const makePlayerIconHtml = (c) =>
  `<div style="width:14px;height:14px;border-radius:50%;background:${c(
    "accent"
  )};border:2px solid ${c("accent", 0.6)};box-shadow:0 0 8px ${c(
    "accent"
  )},0 0 18px ${c("accent", 0.35)};"></div>`;

export const makeAddressIconHtml = (c) =>
  `<div style="width:20px;height:20px;display:flex;align-items:center;justify-content:center;"><svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 3L2 12H5V20H10V14H14V20H19V12H22L12 3M12 8.75C13.24 8.75 14.25 9.76 14.25 11C14.25 12.24 13.24 13.25 12 13.25C10.76 13.25 9.75 12.24 9.75 11C9.75 9.76 10.76 8.75 12 8.75Z" fill="${c(
    "background"
  )}" stroke="${c("link")}" stroke-width="0.5"/></svg></div>`;
